// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","loadingWrapper":"Ga8d4f9","title":"Gf8ab2d","addressSubTitle":"G5722dd","changeAddress":"Ge1f220 Gfbbf38","mobileAddressesList":"G2da32c"};